import React from "react"
import EditFolderModal from "./EditFolderModal"
import { Button } from "reactstrap"
import useDisclosure from "hooks/useDisclosure"
import moment from "moment"
import DeleteModal from "components/Common/DeleteModal"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { deleteFolder } from "api/foldersApi"
import { toast } from "react-toastify"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

function FolderRow({ folderData }) {
  const { id, name, date, documents_count } = folderData
  const queryClient = useQueryClient()
  const editModal = useDisclosure()
  const deleteModal = useDisclosure()
  // delete contract mutation
  const { mutate, isPending } = useMutation({
    mutationFn: deleteFolder,
    onSuccess: () => {
      queryClient.invalidateQueries("folders")
      deleteModal.close()
    },
    onError: error => toast.error(error),
  })

  return (
    <React.Fragment>
      {editModal.isOpen ? (
        <EditFolderModal
          isOpen={editModal.isOpen}
          toggle={editModal.close}
          folderData={folderData}
        />
      ) : null}
      {deleteModal.isOpen ? (
        <DeleteModal
          show={deleteModal.isOpen}
          onDeleteClick={() => mutate(id)}
          onCloseClick={deleteModal.close}
          isLoading={isPending}
        />
      ) : null}
      <tr>
        <td>
          <Link to={{ pathname: "/documents", search: `folder=${name}` }}>
            {name}
          </Link>
        </td>
        <td>{documents_count}</td>
        <td>{moment(date).format("l LT")}</td>
        <td className="d-flex gap-2">
          <Button size="sm" color="soft-success" onClick={editModal.toggle}>
            <i className="bx bx-pencil"></i>
          </Button>
          <Button size="sm" color="soft-danger" onClick={deleteModal.open}>
            <i className="bx bx-trash"></i>
          </Button>
        </td>
      </tr>
    </React.Fragment>
  )
}
FolderRow.propTypes = {
  folderData: PropTypes.object,
}
export default FolderRow
